export default "__VITE_ASSET__InSBOwNq__"